/* eslint-disable */
export default {
  removeParticipant: 'Eliminar participante',
  confirmStr1: '¿Confirma que desea quitarlo',
  confirmStr2: 'de la llamada?',
  remove: 'Eliminar',
  cancel: 'Cancelar',
  participants: 'Participantes',
  participant: 'Participante',
  conferenceCall: 'Conferencia telefónica',
  unknownNumber: 'Anónimo',
} as const;

// @key: @#@"removeParticipant"@#@ @source: @#@"Remove Participant"@#@
// @key: @#@"confirmStr1"@#@ @source: @#@"Are you sure you want to remove"@#@
// @key: @#@"confirmStr2"@#@ @source: @#@"from this call?"@#@
// @key: @#@"remove"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"participant"@#@ @source: @#@"Participant"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
